import React from "react";

type DesignLibraryView =
  | "summary"
  | "colors"
  | "typography"
  | "presets"
  | "fontPresets"
  | "customFonts";

export function useDesignLibrary() {
  const [currentView, setCurrentView] =
    React.useState<DesignLibraryView>("summary");
  const [previousView, setPreviousView] =
    React.useState<DesignLibraryView>("summary");

  const handleCustomFontsClick = () => {
    setPreviousView(currentView);
    setCurrentView("customFonts");
  };

  const handleCustomFontsBack = () => {
    setCurrentView(previousView);
  };

  return {
    // State
    currentView,
    setCurrentView,
    previousView,
    setPreviousView,

    // Handlers
    handleCustomFontsClick,
    handleCustomFontsBack,
  };
}
